import { Component, Input } from '@angular/core';
import { UserResponsiveness } from '@freelancer/datastore/collections';
import { Margin } from '@freelancer/ui/margin';
import { FontColor } from '@freelancer/ui/text';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-user-profile-summary-responsiveness',
  template: `
    <fl-bit class="ResponsivenessRow">
      <fl-online-indicator
        [flMarginRight]="Margin.XSMALL"
        [isOnline]="isOnline$ | flAsync"
      ></fl-online-indicator>
      <fl-text [color]="FontColor.MID">
        <ng-container [ngSwitch]="responsiveness">
          <ng-container *ngSwitchCase="1" i18n="Reply time few days label">
            Replies within a few days
          </ng-container>
          <ng-container *ngSwitchCase="2" i18n="Reply time within a day label">
            Replies within a day
          </ng-container>
          <ng-container
            *ngSwitchCase="3"
            i18n="Reply time withing few hours label"
          >
            Replies within a few hours
          </ng-container>
          <ng-container *ngSwitchCase="4" i18n="Reply time within hour label">
            Replies within an hour
          </ng-container>
          <ng-container
            *ngSwitchCase="5"
            i18n="Reply time within few minutes label"
          >
            Replies within a few minutes
          </ng-container>
        </ng-container>
      </fl-text>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-summary-responsiveness.component.scss'],
})
export class UserProfileSummaryResponsivenessComponent {
  Margin = Margin;
  FontColor = FontColor;

  @Input() responsiveness?: UserResponsiveness;
  @Input() isOnline$: Rx.Observable<boolean>;
}
